export const ST: Record<string, [string, string]> = {
  run: ['run', 'Выполняется'],
  pause: ['pause', 'Пауза'],
  stop: ['stop', 'Остановлена'],
  not_found: ['stop', 'Не найден в поиске'],
};

export const CLST: Record<string, [string, string]> = {
  online: ['run', 'Онлайн'],
  warming: ['pause', 'Прогрев'],
  targeting: ['run', 'Таргет'],
  busy: ['pause', 'Слоты заняты'],
  offline: ['stop', 'Оффлайн'],
  error: ['stop', 'Ошибка'],
  deploying: ['pause', 'Деплой'],
  pending: ['stop', 'Ожидание'],
};

export const CL_UI: Record<string, string> = {
  online: 'online',
  warming: 'busy',
  targeting: 'online',
  busy: 'busy',
  offline: 'off',
  error: 'off',
  deploying: 'off',
  pending: 'off',
};

export const LVL: Record<string, string> = {
  ok: 'успех',
  wa: 'внимание',
  er: 'ошибка',
  '': 'событие',
};

export const DAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
